"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PrettyText_1 = __importDefault(require("../PrettyText"));
const PrettySelect_1 = require("../PrettySelect");
const FieldFocusContext_1 = require("../FieldFocusContext");
const Array_1 = __importDefault(require("../Array"));
function MultiFieldPrettyText(props) {
    const ItemInput = react_1.useCallback(({ index, onChange, value }) => (react_1.default.createElement(FieldFocusContext_1.ExclusiveFieldFocus, null,
        react_1.default.createElement(PrettyText_1.default, { choiceGroups: props.choiceGroups, disabledText: props.disabledText, id: `multi-field-pretty-text-${index}`, initialValue: value, isDisabled: props.isDisabled, onBlur: () => {
                onChange(value, index, { commit: true });
            }, onChange: (newValue, options) => onChange(newValue, index, options), onFocus: () => { }, placeholder: props.placeholder }))), [
        props.choiceGroups,
        props.disabledText,
        props.isDisabled,
        props.placeholder,
    ]);
    return react_1.default.createElement(Array_1.default, Object.assign({}, props, { renderItem: ItemInput }));
}
function MultiFieldPrettySelect(props) {
    const ItemInput = react_1.useCallback(({ index, onChange, value }) => (react_1.default.createElement(PrettySelect_1.PrettySelect, { choiceGroups: props.choiceGroups, commitIfChanged: props.commitIfChanged, disabledText: props.disabledText, isDisabled: props.isDisabled, isLoadingMore: props.isLoadingMore, items: props.items, label: props.label, labelsCache: props.labelsCache, loadMoreState: props.loadMoreState, metadata: props.metadata, onChange: (newValue, options) => onChange(newValue, index, options), onLoadOptions: props.onLoadOptions, placeholder: props.placeholder, shouldSaveOnBlur: false, value: value })), [props]);
    return react_1.default.createElement(Array_1.default, Object.assign({}, props, { renderItem: ItemInput, value: props.value }));
}
function ListField(props) {
    return props.listItemType === 'pretty-select' ? (react_1.default.createElement(MultiFieldPrettySelect, Object.assign({}, props))) : (react_1.default.createElement(MultiFieldPrettyText, Object.assign({}, props)));
}
exports.default = ListField;
